import * as _4 from 'lodash4';
angular
  .module('capability-ng-scheduler')
  .directive('calendarSectionHover', function calendarSectionHover() {
    'use strict';
    return {
      templateUrl: 'capability-ng-scheduler/src/views/components/calendar_section_hover/calendar_section_hover.html',
      bindToController: true,
      scope: {
        courseId: '=',
        sectionId: '='
      },
      controller: 'calendarSectionHoverController as $ctrl'
    };
  })
  .controller(
    'calendarSectionHoverController',
    function (
      this: any,
      $scope: ng.IScope,
      $attrs: ng.IAttributes,
      termRegistrationModel: any,
      sectionViewCommonControllerConst: any,
      sectionViewCommonController: any
    ) {
      const course: any = _4.find(termRegistrationModel.course, { id: parseInt($attrs.courseId, 10) });
      if (!_4.isUndefined($attrs.sectionId)) {
        course._selected_section = _4.find(course._sections, { id: parseInt($attrs.sectionId, 10) });
      }
      this.hoverActionType = sectionViewCommonControllerConst.UNSCHEDULE_SECTION;
      sectionViewCommonController.initializeSection(course, this);
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/components/calendar_section_hover/calendar_section_hover.ts